import { render, staticRenderFns } from "./AdminProductslist.vue?vue&type=template&id=2b6bd3fa"
import script from "./AdminProductslist.vue?vue&type=script&lang=js"
export * from "./AdminProductslist.vue?vue&type=script&lang=js"
import style0 from "./AdminProductslist.vue?vue&type=style&index=0&id=2b6bd3fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports